/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSubscriptionUserList,
    MelcoModelsSubscriptionUserListFromJSON,
    MelcoModelsSubscriptionUserListFromJSONTyped,
    MelcoModelsSubscriptionUserListToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSubscriptionUserList
 */
export interface MelcoModelsGenericList1MelcoModelsSubscriptionUserList {
    /**
     * 
     * @type {Array<MelcoModelsSubscriptionUserList>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionUserList
     */
    list: Array<MelcoModelsSubscriptionUserList>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionUserList
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionUserList
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionUserListFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSubscriptionUserList {
    return MelcoModelsGenericList1MelcoModelsSubscriptionUserListFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSubscriptionUserList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSubscriptionUserListFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionUserListToJSON(value?: MelcoModelsGenericList1MelcoModelsSubscriptionUserList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSubscriptionUserListToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


